function ModeCommunication(mode) {
    switch (mode) {
    case 0:
        return { Icone: 'fas fa-truck', Type: 'Non traité' };
    case 3:
        return { Icone: 'fas fa-fax', Type: 'Fax' };
    case 4:
    case 12:
        return { Icone: 'fas fa-envelope', Type: 'Email' };
    case 6:
    case 13:
        return { Icone: 'fas fa-mobile-alt', Type: 'SMS' };
    case 14:
        return { Icone: 'fas fa-envelope', Type: 'LRE' };
    default:
        return { Icone: 'fas fa-envelope', Type: 'Courrier' };
    }
}

export default ModeCommunication;



// WEBPACK FOOTER //
// ./src/App_Data/ModeCommunication.js